import Range from "./Range";
import { printQualifier } from "../../pages/transactions/overview/cells/printGuidance";
class Size {
    currency;
    value;
    qualifier;
    range;
    isBenchmark;
    isSubBenchmark;
    constructor(response) {
        this.currency = response.currency;
        this.value = response.value;
        this.qualifier = response.qualifier;
        this.range = response.range !== undefined ? new Range(response.range) : undefined;
        this.isBenchmark = response.isBenchmark;
        this.isSubBenchmark = response.isSubBenchmark;
    }
    print() {
        const printIntlNumber = (value) => Intl.NumberFormat().format(value);
        if (this.value !== undefined) {
            const suffix = this.qualifier !== undefined ? printQualifier(this.qualifier) : undefined;
            return { value: this.value / 1000000, suffix };
        }
        if (this.range !== undefined) {
            const { minimum, maximum } = this.range;
            return `${minimum ? printIntlNumber(minimum / 1000000) : '?'} - ${maximum ? printIntlNumber(maximum / 1000000) : '?'}`;
        }
        if (this.isBenchmark) {
            return 'Benchmark';
        }
        if (this.isSubBenchmark) {
            return 'Sub Benchmark';
        }
        return undefined;
    }
}
export default Size;
